module.exports = __webpack_public_path__ + "img/2694.e65939a.svg";